import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Account } from 'src/app/models/AccountModel';
import { ResultFilter, PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { ScanResult } from 'src/app/models/ScanResultModel';
import { ScanTarget } from 'src/app/models/ScanTargetModel';

@Component({
  selector: 'cw-ci-scan-results-list',
  templateUrl: './scan-results-list.component.html',
  styleUrls: []
})
export class ScanResultsListComponent implements OnInit {

  @Input() parentAccount: Account;
  @Input() account: Account;
  @Input() scanTarget: ScanTarget;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();

  scanResultsList: ScanResult[];

  constructor(private _platformApi: PlatformApiService, public sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isSelectable(scan) {
    return true;
  }

  loadScanResults(filter: ResultFilter) {
    let scanResultsListObservable;
    if (this.parentAccount) {
      scanResultsListObservable = this._platformApi.getScanTargetResults(this.parentAccount.id, this.account.id, this.scanTarget.id, filter);
    } else {
      scanResultsListObservable = this._platformApi.getScanTargetResults(this.account.id, undefined, this.scanTarget.id, filter);
    }

    scanResultsListObservable.subscribe(results => {
      this.scanResultsList = results;
    })

  }

  selectScanResult(selectedScanResult: ScanResult) {
    let parentAcctId;
    let subAcctId;
    if (this.parentAccount) {
      parentAcctId = this.parentAccount.id;
      subAcctId = selectedScanResult.accountId;
    } else {
      parentAcctId = selectedScanResult.accountId;
    }

    this._platformApi.getScanTargetResult(parentAcctId, subAcctId, this.scanTarget.id, selectedScanResult.id).subscribe(sr => {
      this.stateChange.emit({state:'SELECT_SCAN_TARGET_RESULT', item:sr});
    });
  }

  executeScan(event?) {

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptTitle: 'Execute Vulnerability Scan',
        promptMessage: [
          'Running a vulnerability scan may take 10 minutes or more and may cause a degradation in performance on the computer being scanned. Do you want to execute the scan?'
        ],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:true, color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(executeScan => {
      if (executeScan) {
        let parentAcctId;
        let subAcctId;
        if (this.parentAccount) {
          parentAcctId = this.parentAccount.id;
          subAcctId = this.account.id;
        } else {
          parentAcctId = this.account.id;
        }

        this._platformApi.executeScan(parentAcctId, subAcctId, this.scanTarget.id, 380, this.scanTarget.externalId).subscribe(res => {
          const checkDialog = this.dialog.open(ConfirmationComponent, {
            panelClass: 'flush-dialog',
            data: {
              promptTitle: 'Running',
              promptMessage: [
                'The scan is currently running. Check back soon to access the results.'
              ],
              showClose: false,
              height: 'auto'
            }
          });
        }, err => {
          const errDialog = this.dialog.open(ConfirmationComponent, {
            panelClass: 'flush-dialog',
            data: {
              promptTitle: 'Error',
              promptMessage: [
                'An error was encountered running the scan.',
                JSON.stringify(err, null, 2)
              ],
              showClose: false,
              height: 'auto'
            }
          });
        })
      }
    });
  }
}
